var _defs, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelTeaser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ss-blur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-low",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(200, 85%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(200, 85%, 42%)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-aprmay",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(22, 38%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(22, 38%, 42%)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-highest",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(140, 60%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(140, 60%, 42%)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-oct",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(335, 80%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(335, 80%, 42%)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-nov",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(318, 70%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(318, 70%, 42%)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ss-g-lowest",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "hsl(258, 55%, 64%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(258, 55%, 42%)"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ss-arrow",
    viewBox: "0 0 12 12",
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    refX: 0,
    refY: 6,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ss-marker",
    d: "M0,0 L12,6 L0,12 L3,6 z",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ss-arrow-dim",
    viewBox: "0 0 12 12",
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    refX: 0,
    refY: 6,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ss-marker",
    d: "M0,0 L12,6 L0,12 L3,6 z",
    fill: "#a0a0a0",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ss-arrow-sel",
    viewBox: "0 0 12 12",
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    refX: 0,
    refY: 6,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ss-marker-sel",
    d: "M0,0 L12,6 L0,12 L3,6 z",
    fill: "#337ab7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ss-glow",
    opacity: 0.12,
    filter: "url(#ss-blur)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 300,
    r: 170,
    fill: "hsl(140, 70%, 45%)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 280,
    r: 170,
    fill: "hsl(225, 70%, 55%)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 520,
    r: 120,
    fill: "hsl(325, 60%, 50%)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M362.3,199.5 Q445.4,212.2 506.2,163.3",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.95,
    strokeWidth: 6.2,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M586.9,170.2 Q635.4,260.6 699.9,277.0",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.95,
    strokeWidth: 7.1,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M601.3,526.4 Q522.6,498.8 452.2,511.0",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.95,
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M379.4,484.6 Q325.2,391.6 245.5,374.2",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.6,
    strokeWidth: 4,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M398.4,479.0 Q392.9,342.0 339.1,254.0",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.95,
    strokeWidth: 4.8,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M227.1,331.6 Q277.4,301.4 285.1,263.5",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.95,
    strokeWidth: 7.2,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M246.0,222.5 Q202.6,248.6 193.3,294.3",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.6,
    strokeWidth: 3,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M503.7,111.4 Q414.6,97.8 358.4,143.0",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.55,
    strokeWidth: 1.4,
    strokeDasharray: "3 6",
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow-dim)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M673.9,516.9 Q767.8,453.0 776.6,392.0",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.55,
    strokeWidth: 1.4,
    strokeDasharray: "3 6",
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow-dim)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link",
    d: "M207.7,407.5 Q254.8,488.4 348.2,508.7",
    fill: "none",
    stroke: "#a0a0a0",
    strokeOpacity: 0.55,
    strokeWidth: 1.4,
    strokeDasharray: "3 6",
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow-dim)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link-sel",
    d: "M723.0,345.6 Q662.2,387.0 647.6,487.5",
    fill: "none",
    stroke: "#337ab7",
    strokeWidth: 7.3,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow-sel)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-flow",
    d: "M723.0,345.6 Q662.2,387.0 647.6,487.5",
    fill: "none",
    stroke: "#e3f2fd",
    strokeWidth: 3.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-link-sel",
    d: "M751.7,228.6 Q714.6,159.4 626.9,137.0",
    fill: "none",
    stroke: "#337ab7",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    markerEnd: "url(#ss-arrow-sel)",
    strokeDasharray: "3 6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 300,
    cy: 190,
    r: 69,
    fill: "hsl(200, 85%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 190,
    r: 60,
    fill: "url(#ss-g-low)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 180.1,
    fontSize: 17,
    fontWeight: 500,
    fill: "#ffffff",
    fillOpacity: 0.9,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Rainfall"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 201.7,
    fontSize: 18,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 0.5,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "LOW"), /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 560,
    cy: 120,
    r: 62.1,
    fill: "hsl(22, 45%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 120,
    r: 54,
    fill: "url(#ss-g-aprmay)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 121,
    fontSize: 17,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Apr \u2013 May"), /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 790,
    cy: 300,
    r: 89.7,
    fill: "hsl(140, 60%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ss-sel",
    cx: 790,
    cy: 300,
    r: 87,
    fill: "none",
    stroke: "#337ab7",
    strokeWidth: 2,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "85;102;85",
    dur: "2.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0;0.7",
    dur: "2.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "ss-sel",
    cx: 790,
    cy: 300,
    r: 81,
    fill: "none",
    stroke: "#337ab7",
    strokeWidth: 5,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 300,
    r: 78,
    fill: "url(#ss-g-highest)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 287.4,
    fontSize: 22,
    fontWeight: 500,
    fill: "#ffffff",
    fillOpacity: 0.9,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Rainfall"), /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 314.9,
    fontSize: 23,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 0.5,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "HIGHEST"), /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 640,
    cy: 540,
    r: 43.7,
    fill: "hsl(335, 80%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 540,
    r: 38,
    fill: "url(#ss-g-oct)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 541,
    fontSize: 16,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Oct"), /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 400,
    cy: 520,
    r: 43.7,
    fill: "hsl(318, 70%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 520,
    r: 38,
    fill: "url(#ss-g-nov)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 521,
    fontSize: 16,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Nov"), /*#__PURE__*/React.createElement("circle", {
    className: "ss-node-glow",
    cx: 180,
    cy: 360,
    r: 59.8,
    fill: "hsl(258, 55%, 55%)",
    opacity: 0.2,
    filter: "url(#ss-blur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 360,
    r: 52,
    fill: "url(#ss-g-lowest)",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 351.2,
    fontSize: 15,
    fontWeight: 500,
    fill: "#ffffff",
    fillOpacity: 0.9,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Rainfall"), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 370.4,
    fontSize: 16,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 0.5,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "LOWEST"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 13,
    fontWeight: 600,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 417.8,
    y: 186.8,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 439.8,
    y: 197.3,
    fill: "rgba(0,0,0,0.7)"
  }, "0.76"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 617.4,
    y: 232.1,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 639.4,
    y: 242.6,
    fill: "rgba(0,0,0,0.7)"
  }, "0.91"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 502.7,
    y: 498.7,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 524.7,
    y: 509.2,
    fill: "rgba(0,0,0,0.7)"
  }, "0.74"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 296.8,
    y: 400.5,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 318.8,
    y: 411,
    fill: "rgba(0,0,0,0.7)"
  }, "0.40"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 358.8,
    y: 344.3,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 380.8,
    y: 354.8,
    fill: "rgba(0,0,0,0.7)"
  }, "0.53"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 244.8,
    y: 289.5,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 266.8,
    y: 300,
    fill: "rgba(0,0,0,0.7)"
  }, "0.94"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill",
    x: 189.1,
    y: 243.5,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text",
    x: 211.1,
    y: 254,
    fill: "rgba(0,0,0,0.7)"
  }, "0.24"), /*#__PURE__*/React.createElement("rect", {
    className: "ss-pill ss-pill-sel",
    x: 651.8,
    y: 391.8,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#ffffff",
    stroke: "#337ab7"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-pill-text ss-pill-text-sel",
    x: 673.8,
    y: 402.3,
    fill: "#337ab7"
  }, "0.95"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "ss-caption",
    x: 40,
    y: 600,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "rgba(0,0,0,0.54)",
    letterSpacing: 1.6
  }, "SCALES"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 610,
    width: 96.9,
    height: 14,
    rx: 2,
    fill: "hsl(240, 28%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.9,
    y: 610,
    width: 53.2,
    height: 14,
    rx: 2,
    fill: "hsl(350, 28%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.1,
    y: 610,
    width: 73.9,
    height: 14,
    rx: 2,
    fill: "hsl(140, 28%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 628,
    width: 44,
    height: 14,
    rx: 2,
    fill: "hsl(200, 85%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 628,
    width: 32.5,
    height: 14,
    rx: 2,
    fill: "hsl(258, 55%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 628,
    width: 16.4,
    height: 14,
    rx: 2,
    fill: "hsl(318, 70%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.9,
    y: 628,
    width: 34.8,
    height: 14,
    rx: 2,
    fill: "hsl(22, 38%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.7,
    y: 628,
    width: 16.4,
    height: 14,
    rx: 2,
    fill: "hsl(335, 80%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.1,
    y: 628,
    width: 73.9,
    height: 14,
    rx: 2,
    fill: "hsl(140, 60%, 52%)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ss-caption",
    d: "M278,635.0 l10,-5 l0,10 z",
    fill: "rgba(0,0,0,0.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ss-caption",
    x: 294,
    y: 636,
    fontSize: 11,
    fill: "rgba(0,0,0,0.54)",
    dominantBaseline: "middle"
  }, "current"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 646,
    width: 21,
    height: 14,
    rx: 2,
    fill: "hsl(191, 100%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 646,
    width: 21,
    height: 14,
    rx: 2,
    fill: "hsl(209, 100%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 646,
    width: 15.2,
    height: 14,
    rx: 2,
    fill: "hsl(249, 70%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 646,
    width: 15.2,
    height: 14,
    rx: 2,
    fill: "hsl(267, 70%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 646,
    width: 7.2,
    height: 14,
    rx: 2,
    fill: "hsl(309, 85%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.7,
    y: 646,
    width: 7.2,
    height: 14,
    rx: 2,
    fill: "hsl(327, 85%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.9,
    y: 646,
    width: 16.4,
    height: 14,
    rx: 2,
    fill: "hsl(13, 53%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.3,
    y: 646,
    width: 16.4,
    height: 14,
    rx: 2,
    fill: "hsl(31, 53%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.7,
    y: 646,
    width: 7.2,
    height: 14,
    rx: 2,
    fill: "hsl(326, 95%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 646,
    width: 7.2,
    height: 14,
    rx: 2,
    fill: "hsl(344, 95%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.1,
    y: 646,
    width: 36,
    height: 14,
    rx: 2,
    fill: "hsl(131, 75%, 52%)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 646,
    width: 36,
    height: 14,
    rx: 2,
    fill: "hsl(149, 75%, 52%)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTeaser);
export default __webpack_public_path__ + "static/media/model-teaser.12277ae6.svg";
export { ForwardRef as ReactComponent };